import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'edge-page-accounts',
  templateUrl: './page-accounts.component.html',
  styleUrls: ['./page-accounts.component.scss']
})
export class PageAccountsComponent implements OnInit {
  sport: string = '';
  email: string = '';
  vcode: string = '';
  currentRoute: string = '';

  constructor(private router: ActivatedRoute) {}

  ngOnInit(): void {
    this.currentRoute = this.router.snapshot.url[2].path;
    this.sport = this.router.snapshot.params.sport;
    this.email = this.router.snapshot.queryParams.email;
    this.vcode = this.router.snapshot.queryParams.vcode;
  }
}
